import React, { Suspense, useMemo } from 'react'
import { ToastAlertProvider } from '@design-systems/canvas-ui'
import SectionSkeleton from './skeletons/SectionSkeleton'
import { useData } from '../context/DataContext'
import {
  getCountryName,
  getObjectDataNode,
  getUniqueKeyName,
} from '../../../../common/helper'
import { getTabIdByNameSafe } from '../utils/tabUtils'
import { getSectionComponent } from '../registry/SectionRegistry'
const SECTION_NAME_SUFFIX_BY_UID = {
  footwear_factory_ownership: '(Footwear)',
}

const decorateSectionTemplate = (section) => {
  if (!section) return section
  const suffix = SECTION_NAME_SUFFIX_BY_UID[section.uid]
  if (!suffix || !section.section_name) return section
  if (section.section_name.includes(suffix)) return section
  return {
    ...section,
    section_name: `${section.section_name} ${suffix}`,
  }
}

export default function TabBody({
  rfiType,
  isRenderReadOnlySection,
  manufacturingTypeId,
  saveRfiPayload,
}) {
  const { state: d } = useData()

  const currentTab = useMemo(() => {
    const tabs = d?.template?.dynamic_sections?.tabs || []
    return tabs.find((t) => t.tab_name === d.activeTab)
  }, [d.template, d.activeTab])

  const sections = currentTab?.sections || []
  const tabUid = getTabIdByNameSafe(d.template, d.tabUidByName, d.activeTab)

  return (
    <ToastAlertProvider location="top">
      {sections.map((section) => {
        const Component = getSectionComponent(section.uid, {
          isReadonly: isRenderReadOnlySection,
        })
        const sectionData = getObjectDataNode(
          d.rfiObject,
          d.templateDataMapper[section.uid],
        )
        const sectionPath = `${tabUid}.${section.uid}`
        const country = getCountryName(d.rfiObject, rfiType)

        return (
          <Suspense
            key={getUniqueKeyName(section.uid, 'sec')}
            fallback={<SectionSkeleton />}
          >
            <Component
              sectionPath={sectionPath}
              errorCache={d.errorCache}
              sectionTemplate={decorateSectionTemplate(section)}
              sectionData={sectionData}
              rfiMasterData={d.masterData}
              rfiType={rfiType}
              saveRfiPayload={saveRfiPayload}
              manufacturingTypeId={manufacturingTypeId}
              isReadonly={isRenderReadOnlySection}
              supplierId={d.rfiObject?.supplier_id}
              locationId={d.rfiObject?.location_id}
              country={country}
            />
          </Suspense>
        )
      })}
    </ToastAlertProvider>
  )
}
